import React from 'react';

export interface OfflineBannerProps {
  /** Exibe banner quando API está indisponível (distinto do ícone no header). */
  visible: boolean;
}

/**
 * Banner fixo no topo quando a API/VPS está offline — feedback claro além do ícone vermelho.
 * @param props - Controle de visibilidade
 */
export const OfflineBanner: React.FC<OfflineBannerProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 inset-x-0 z-[9998] bg-amber-500 text-white text-center text-[11px] font-semibold py-1.5 px-4 shadow-md animate-in slide-in-from-top duration-300"
    >
      Sem conexão com o servidor. Tentando reconectar automaticamente…
    </div>
  );
};
